import { component } from "picoapp";
import isUSA from "../lib/customerLocation";

export default component(async (node) => {
  try {
    if (isUSA()) {
      node.innerHTML =
        "<p>Try risk-free for 100-days. Shipping and returns are always free.</p>";
    }
  } catch (err) {
    return err;
  }
});
